// IMPORTS
import { ref, computed } from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown';
import countDownDisplay from './countDownDisplay';
import { store } from '../../store/store';

/*
PLUGIN: https://fengyuanchen.github.io/vue-countdown/
*/

import countDownStyles from "../../css/countdown.scss";

/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'CountDownContainer',

    /* Any imported component for this file needs to be listed here */
    components: {
        VueCountdown,
        countDownDisplay
    },

    /* Declare any expected props here */
    props: {
        targetTime: {
            type: String,
            required: true
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        // INIT
        const cdClass = ref('');
        const targetMilliseconds = ref(0);
        const countdownEnded = ref(false);

        const currentTime = computed(() => {
            return store.state.getCurrentTime();
        });
        
        function checkCounter() {
            targetMilliseconds.value = store.time.getTimeDiff(currentTime.value.dateTime, props.targetTime);
            cdClass.value = store.time.calcTimeClass(targetMilliseconds.value);
        }
        checkCounter();

        /*
        Using interval to update cdClass every second for dynamic class changes downstream
        */
        const intCount = setInterval(() => {
            checkCounter();
        }, 1000);

        function transformSlotProps(props) {
            const formattedProps = {};
            
            Object.entries(props).forEach(([key, value]) => {
                formattedProps[key] = value < 10 ? `0${value}` : String(value);
            });

            return formattedProps;
        }

        function handleCountdownEnd() {
            countdownEnded.value = true;
            store.widget.determineWidgetStep();
            console.log('the countdown ended');
        }

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            targetMilliseconds,
            cdClass,
            transformSlotProps,
            handleCountdownEnd,
            countdownEnded
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <div class="cfm_ec_countdown_container"
        v-if="!countdownEnded"
        >
            
            <vue-countdown
            :time="targetMilliseconds" 
            :transform="transformSlotProps"
            v-slot="slotData"
            @end="handleCountdownEnd"
            >
                
                <count-down-display
                :cdClass="cdClass"
                :slotData="slotData"
                ></count-down-display>
               
            </vue-countdown>

        </div>
    `,
}